<button
    #downloadBtn
    [mktRouterLink]="csp.addToBrowserUrl()" 
    cdsButton="primary" type="button"
    [ngClass]="buttonColor == 'white' ? 'white-button' : ''"
    [attr.aria-label]="csp.addToBrowserBtnLbl() ? csp.addToBrowserBtnLbl() : csp.downloadNowBtnLbl()"
    (click)="onAddToDownloadBtnClick()"
    [innerHTML]="csp.addToBrowserBtnLbl() ? csp.addToBrowserBtnLbl() : csp.downloadNowBtnLbl()"
></button>